import { render, staticRenderFns } from "./DossierView.vue?vue&type=template&id=1aa3b04a"
import script from "./DossierView.vue?vue&type=script&lang=js"
export * from "./DossierView.vue?vue&type=script&lang=js"
import style0 from "./DossierView.vue?vue&type=style&index=0&id=1aa3b04a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports